import { GET_WHATSAPP_CONTACTS } from "../../../../routes/ApiEndpoints";
import { ApiCall } from "components/common/services/ApiServices";
import { AJ_WEB_CONNECTOR } from "Constants";
import type { filterDataProps } from "../annotations/WhatsAppAnnotations";

/**
 * Fetch messages based on personID.
 */
export const FetchWhatsAppContacts = async (filterData:filterDataProps) => {
  const response = await ApiCall.service(
    GET_WHATSAPP_CONTACTS,
    "POST",
    filterData,
    false,
    AJ_WEB_CONNECTOR,
  );

  return response;
};
